import { isIpad, detectDeviceType } from "./deviceType"
export const getFocus = (id: string) => {
  const device = detectDeviceType()
  if (device !== "AndroidTab" && isIpad() === false) {
    document.getElementById(id)?.focus()
  }
}
